"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IKeyValueStorage = void 0;
class IKeyValueStorage {
}
exports.IKeyValueStorage = IKeyValueStorage;
